import hasKey from 'lodash/has';
import LocalStorage from '../LocalStorage';

class Gtm {
  static lastExtraKeys = new Set();

  static defaultEvent = {
    event: '',
    eventCategory: '',
    eventAction: '',
    eventLabel: '',
    eventValue: '',
  };

  static defaultPageView = {
    event: 'vpv',
    virtualPagePath: '',
    utmChannel: '',
    utmSource: '',
    utmMedium: '',
    utmCampaign: '',
    utmAdgroup: '',
    utmKeyword: '',
    utmCreative: '',
    utmDevice: '',
    utmNetwork: '',
    utmLocation: '',
    gclid: '',
    msclkid: '',
  };

  static createPayload(type, o) {
    const data = o || {};
    const defaultPayload = Gtm[`default${type}`];
    const payload = {};
    Object.keys(defaultPayload).forEach((key) => {
      payload[key] = hasKey(data, key) ? data[key] : defaultPayload[key];
    });

    Gtm.lastExtraKeys.forEach((key) => {
      if (!(key in (o?.extraParams || {}))) {
        payload[key] = undefined;
      }
    });

    Gtm.lastExtraKeys.clear();
    if (o?.extraParams) {
      Object.keys(o.extraParams).forEach((key) => {
        Gtm.lastExtraKeys.add(key);
      });
    }

    return { ...payload, ...o?.extraParams };
  }

  static trackEvent(o) {
    window.dataLayer.push(Gtm.createPayload('Event', o));
  }

  static changeDataLayer(data) {
    window.dataLayer.push(data);
  }

  static trackPageView(path) {
    const utmParams = LocalStorage.getUtmParams();
    if (window.dataLayer) window.dataLayer.push(Gtm.createPayload('PageView', { virtualPagePath: path, ...utmParams }));
  }

  static removeTransactionData() {
    window.dataLayer.push({
      transactionId: undefined,
      transactionTotal: undefined,
      bookingtype: undefined,
      transactionProducts: undefined,
    });
  }
}

export default Gtm;
